export enum AttendButtonType {
  room = 'room',
  workshop = 'workshop',
}
